<template>

<app-view-list-field :is-sticky="isSticky" :field="field" :filter="filter">

    <span class="version">{{ version }}</span>

</app-view-list-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky'],

    computed: {

        version: function() {

			if (this.item.game.version) {

				var version = ''

				version += this.item.game.version.name + ((this.item.game.version.year) ? ' (' + this.item.game.version.year + ')' : '')

				return version

			} else {

				return ''

			}

		}

    }

}

</script>

<style scoped>

.version {
	color: #333;
	font-weight: 500;
	font-size: 16px;
	line-height: 16px;
}

.is-mobile .version {
	font-size: 14px;
}

</style>